const ClearFieldsMobileCont = ({
  searchData,
  hasFilters,
  callback,
  children,
}) => {
  const clickEvent = () => {
    callback(true);
  };
  return (
    <div className={`search__results ${hasFilters ? "is-active" : ""}`}>
      <span onClick={() => clickEvent()}>
        {searchData.city.name ? searchData.city.name : null}
        {searchData.activityFacility.name && searchData.city.name ? ", " : null}
        {searchData.activityFacility.name ? searchData.activityFacility.name : null}
      </span>
      {children}
    </div>
  );
};
export default ClearFieldsMobileCont;
